import { createVanIconComponent } from "./van"

const FreePostage = createVanIconComponent("free-postage")
export default FreePostage
